document.addEventListener('DOMContentLoaded', async function () {
  try {
    // Session'da kontrol et (tarayıcı kapanana kadar geçerli)
    if (sessionStorage.getItem('discount_source_set')) {
      return;
    }

    // Cart'ta var mı kontrol et
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    if (cart.attributes && cart.attributes.discount_source) {
      sessionStorage.setItem('discount_source_set', 'true');
      return;
    }

    // Yoksa ekle
    const discountSource = {
      purchase_source: 'web'
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'discount_source': JSON.stringify(discountSource)
        }
      })
    });

    sessionStorage.setItem('discount_source_set', 'true');
    // console.log('Cart attributes güncellendi:', discountSource);
  } catch (error) {
    console.error('Cart attributes işlemi hatası:', error);
  }
});